import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children", "headingType", "level"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { HEADING_LEVELS, HEADING_TYPES } from "../constants";
import { headingVariantStyles } from "../variant-styles";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledHeading = styled.h1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant;
  return variant && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n    "])), headingVariantStyles[variant]);
});

var Heading = function Heading(_ref2) {
  var children = _ref2.children,
      headingType = _ref2.headingType,
      level = _ref2.level,
      other = _objectWithoutProperties(_ref2, _excluded);

  var Tag = "h".concat(Math.min(level, 6));
  return /*#__PURE__*/_jsx(StyledHeading, _objectSpread(_objectSpread({
    as: Tag,
    variant: headingType
  }, other), {}, {
    children: children
  }));
};

Heading.displayName = "Heading";
Heading.propTypes = {
  /** Adds any content between tags */
  children: PropTypes.node,

  /** Sets the heading styles. */
  headingType: PropTypes.oneOf(Object.values(HEADING_TYPES)),

  /** Sets heading tag level (depth) and applies style. Values: [1, 2, 3, 4, 5, 6] */
  level: PropTypes.oneOf(Object.values(HEADING_LEVELS))
};
Heading.defaultProps = {
  children: null,
  headingType: HEADING_TYPES.DISPLAY_1,
  level: HEADING_LEVELS.LEVEL_1
};
export { Heading };